import { Link } from "react-router-dom";

export default function TransportationHero() {
    return (
        <section>
            <div className="pt-6 md:pt-14 pb-2">
                <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
                    {/* Text Content */}
                    <div className="ms-0 lg:ms-8">
                        <div>
                            <h3 className="text-indigo-900 text-[14.5px] md:text-base lg:text-lg font-semibold mb-1.5">
                                Trusted Partner
                            </h3>
                            <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-5xl font-bold text-blue-900 leading-tight w-[90%] lg:w-full">
                                Safe Daily Employee Transportation
                            </h1>
                            <p className="text-gray-700 text-sm sm:text-base md:text-lg mt-3 mb-3 font-medium">
                                Ensuring safe, reliable commutes for employees with professional and timely transport service.
                            </p>

                            <Link to="/contact" className="bg-green-900 text-white px-2.5 py-1.5 md:px-4 text-sm sm:text-base md:py-2 rounded-sm shadow hover:bg-green-700 transition font-bold">
                                Contact Us
                            </Link>
                        </div>
                    </div>


                    {/* Video Content */}
                    <div className="overflow-hidden flex justify-center items-center">
                        <img
                            width="100%"
                            src="/safe-office-transport.png"

                            className="w-[70%]  object-cover"
                        />
                    </div>
                </div>
            </div>
            <hr className="mt-4" />
            <hr className="mt-[1px] border-2" />
        </section>
    )
}